"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

/**
    A string hashing function based on Daniel J. Bernstein's popular 'times 33' hash algorithm.
*/
function hash(text) {
  var hash = 5381;
  var index = text.length;

  while (index) {
    hash = hash * 33 ^ text.charCodeAt(--index);
  }

  return hash >>> 0;
}

var useHash = function useHash(input) {
  return (0, _react.useMemo)(function () {
    return hash(input).toString(16);
  }, [input]);
};

var _default = useHash;
exports["default"] = _default;